import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import myImg from "../../Assets/pic.png";

import TypeWriter from "./TypeWriter";
import Wrapper from "./Wrappe";

function Home() {
  return ( <Wrapper>
    
  <div id="home">
    <section>
      <Container fluid className="home-section" id="home">
        <Container className="home-content">
          <Row>
            <Col md={6} className="home-header">
              <h1 style={{ paddingBottom: 15 }} className="heading">
                Hi There!{" "}
                <span className="wave" role="img" aria-labelledby="wave">
                  👋🏻
                </span>
              </h1>

              <h1 className="heading-name">
                I'M{" "}
                <strong className="main-name"><span style={{
                  color:"#E31B6D"
                }}>Ritik Gupta</span></strong>
              </h1>

              <p className="heading-description blockquote">
                I’m a passionate Full Stack Web Developer, trained in FrontEnd & BackEnd Development, Data Structures and Algorithms at Masai School, It's military style intensive bootcamp
              </p>

              <div className="heading-type" >
                <TypeWriter />
              </div>
            </Col>

            <Col md={5}>
              <img src={myImg} className="profile-pic" alt="avatar" />
            </Col>
          </Row>
        </Container>
      </Container>
      <Container fluid className="home-about-section" id="about">
     
      </Container>
    </section>
  </div>
  </Wrapper>

  );
}

export default Home;
